import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import CircleLoader from "react-spinners/CircleLoader";
import Admin_Layout from "../../../Admin/Components/Common/Admin_Layout/Admin_Layout";
import Layout from "../../Layout/Layout";
import NotFound from "../../NotFound/NotFound";

const routes = [
    {
        path: '/treatment-Details/:id',
        Component: lazy(() => import('../../../page/TreatmentDetails/TreatmentDetails')),
        exact: true,
    },
]
const Admin_routes = [
    {
        path: '/Admin/dashboard',
        Component: lazy(() => import('../../../Admin/Page/Dashboard/Dashboard')),
        exact: true,
    },
    {
        path: '/Admin/treatment',
        Component: lazy(() => import('../../../Admin/Page/Treatment_Add/Treatment_Add')),
        exact: true,
    },
    {
        path: '/Admin/treatment_Details',
        Component: lazy(() => import('../../../Admin/Page/Treatment_Details_Add/Treatment_Details_Add')),
        exact: true,
    },
    {
        path: '/Admin/Billing',
        Component: lazy(() => import('../../../Admin/Page/Billing/Billing')),
        exact: true,
    },
]
const AuthenticatedRouter = () => {
    return (
        <div>
            <Suspense fallback={<div className="loader">
                <CircleLoader size={50} color="#157160" />
            </div>}>
                <Switch>
                    {
                        routes.map((route, idx) => (
                            <Route exact={route.exact} key={idx} path={`${route.path}`}>
                                <Layout>
                                    <route.Component />
                                </Layout>
                            </Route>
                        ))
                    }
                    {
                        Admin_routes.map((route, idx) => (
                            <Route exact={route.exact} key={idx} path={`${route.path}`}>
                                <Admin_Layout>
                                    <route.Component />
                                </Admin_Layout>
                            </Route>
                        ))
                    }
                    <Route component={NotFound} />
                </Switch>
            </Suspense>
        </div>
    );
};

export default AuthenticatedRouter;